import { CONTENT } from './contentActions';

import type { ReduxState } from '$redux/store';

export const stateSelector = (state: ReduxState) => state[CONTENT];
